import React from 'react'
import { Link } from "react-router-dom";
import styled from 'styled-components'
import logo from '../../assets/logo.png'
import RightMenu from './Sections/RightMenu';

function NavBar() {

  return (
    <Container>
        <NavWrapper>
            <MenuLogo>
                <Link to="/">
                    <img src={logo} style={{ width: "160px", height:"100%" }} alt="logo" />
                </Link>
            </MenuLogo>
            <RightMenu/>          
        </NavWrapper>
    </Container>
  )
}

const Container = styled.div`
    position: fixed;
    z-Index: 10;
    width: 100%;    
    background-color: white;
    display: flex;
    justify-Content: center;
    /* background-Color: rgba(91, 102, 112); */
    margin: auto;
    padding: 0px;
    /* border-bottom: solid 1px #e8e8e8; */
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
    height: 60px;
`;

const NavWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-Content: space-between;
    width: 80%;  
`;

const MenuLogo = styled.div`    
    width: 200px;
    height: 100%;
    padding: 20px;    
    float: left;
    align-items: center;
    display: flex; 
`;
export default NavBar